import { useEffect, useMemo, useState } from 'react'
import { groupByLetter, railLettersFor } from '@/utils/indexLetter'

export function useLetterGlas<T>(items: T[], getText: (item: T) => string) {
  const [letter, setLetter] = useState<string | null>(null)
  const [hoverLetter, setHoverLetter] = useState<string | null>(null)

  const grouped = useMemo(() => groupByLetter(items, getText), [items, getText])
  const have = useMemo(() => new Set(grouped.map(([L]) => L)), [grouped])
  const letters = useMemo(() => railLettersFor(have), [have])
  const focusLetter = hoverLetter ?? letter

  useEffect(() => {
    if (letter && !have.has(letter)) setLetter(null)
    if (hoverLetter && !have.has(hoverLetter)) setHoverLetter(null)
  }, [have, letter, hoverLetter])

  return {
    letter,
    setLetter,
    hoverLetter,
    setHoverLetter,
    focusLetter,
    have,
    letters,
    grouped,
  }
}
